/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Rtx.Verbum.Api | v1
 * OpenAPI spec version: 1.0.0
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { customInstance } from '../../../../core/custom-instance'
import type {
  DataEnvelopeOfAnalyticsResponseDto,
  DataEnvelopeOfReadershipDashboardDto,
  GetFilteredAnalyticsParams,
  GetReadershipDashboardParams,
} from '../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

/**
 * @summary Painel de primeira leitura por destinatário da audiência publicada
 */
export const getReadershipDashboard = (
  params?: GetReadershipDashboardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfReadershipDashboardDto>(
    { url: `/v1/analytics/readership`, method: 'GET', params, signal },
    options,
  )
}

export const getGetReadershipDashboardQueryKey = (params?: GetReadershipDashboardParams) => {
  return [`/v1/analytics/readership`, ...(params ? [params] : [])] as const
}

export const getGetReadershipDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getReadershipDashboard>>,
  TError = unknown,
>(
  params?: GetReadershipDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReadershipDashboard>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetReadershipDashboardQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReadershipDashboard>>> = ({ signal }) =>
    getReadershipDashboard(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReadershipDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReadershipDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReadershipDashboard>>
>
export type GetReadershipDashboardQueryError = unknown

export function useGetReadershipDashboard<
  TData = Awaited<ReturnType<typeof getReadershipDashboard>>,
  TError = unknown,
>(
  params: undefined | GetReadershipDashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReadershipDashboard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadershipDashboard>>,
          TError,
          Awaited<ReturnType<typeof getReadershipDashboard>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadershipDashboard<
  TData = Awaited<ReturnType<typeof getReadershipDashboard>>,
  TError = unknown,
>(
  params?: GetReadershipDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReadershipDashboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReadershipDashboard>>,
          TError,
          Awaited<ReturnType<typeof getReadershipDashboard>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReadershipDashboard<
  TData = Awaited<ReturnType<typeof getReadershipDashboard>>,
  TError = unknown,
>(
  params?: GetReadershipDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReadershipDashboard>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Painel de primeira leitura por destinatário da audiência publicada
 */

export function useGetReadershipDashboard<
  TData = Awaited<ReturnType<typeof getReadershipDashboard>>,
  TError = unknown,
>(
  params?: GetReadershipDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReadershipDashboard>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReadershipDashboardQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

/**
 * @summary Retorna dados de analytics
 */
export const getAnalytics = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfAnalyticsResponseDto>(
    { url: `/v1/analytics`, method: 'GET', signal },
    options,
  )
}

export const getGetAnalyticsQueryKey = () => {
  return [`/v1/analytics`] as const
}

export const getGetAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAnalytics>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>>
  request?: SecondParameter<typeof customInstance>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAnalyticsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalytics>>> = ({ signal }) =>
    getAnalytics(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalytics>>>
export type GetAnalyticsQueryError = unknown

export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAnalytics>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getAnalytics>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retorna dados de analytics
 */

export function useGetAnalytics<TData = Awaited<ReturnType<typeof getAnalytics>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalytics>>, TError, TData>>
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAnalyticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getFilteredAnalytics = (
  params?: GetFilteredAnalyticsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DataEnvelopeOfAnalyticsResponseDto>(
    { url: `/v1/analytics/filtered`, method: 'GET', params, signal },
    options,
  )
}

export const getGetFilteredAnalyticsQueryKey = (params?: GetFilteredAnalyticsParams) => {
  return [`/v1/analytics/filtered`, ...(params ? [params] : [])] as const
}

export const getGetFilteredAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFilteredAnalytics>>,
  TError = unknown,
>(
  params?: GetFilteredAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFilteredAnalytics>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFilteredAnalyticsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFilteredAnalytics>>> = ({ signal }) =>
    getFilteredAnalytics(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFilteredAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilteredAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFilteredAnalytics>>
>
export type GetFilteredAnalyticsQueryError = unknown

export function useGetFilteredAnalytics<
  TData = Awaited<ReturnType<typeof getFilteredAnalytics>>,
  TError = unknown,
>(
  params: undefined | GetFilteredAnalyticsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFilteredAnalytics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilteredAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getFilteredAnalytics>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilteredAnalytics<
  TData = Awaited<ReturnType<typeof getFilteredAnalytics>>,
  TError = unknown,
>(
  params?: GetFilteredAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFilteredAnalytics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFilteredAnalytics>>,
          TError,
          Awaited<ReturnType<typeof getFilteredAnalytics>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFilteredAnalytics<
  TData = Awaited<ReturnType<typeof getFilteredAnalytics>>,
  TError = unknown,
>(
  params?: GetFilteredAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFilteredAnalytics>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFilteredAnalytics<
  TData = Awaited<ReturnType<typeof getFilteredAnalytics>>,
  TError = unknown,
>(
  params?: GetFilteredAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFilteredAnalytics>>, TError, TData>
    >
    request?: SecondParameter<typeof customInstance>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFilteredAnalyticsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
